import * as data from './_data';
import * as edge from './_edge';
import useProcessFlow from './_flow';
import * as layout from './_layout';
import * as node from './_node';
import * as step from './step/_step';
import * as detectBarcode from './step/action/_detect-barcode';
import * as condition from './step/condition/_condition';
import * as conditionPath from './step/condition/_path';
import * as connectorRcip from './step/connector/_rcip';
import * as taskCommon from './step/task/_common';
import * as taskConnector from './step/task/_connector';
import * as taskImport from './step/task/_import';
import * as taskRoutingCloud from './step/task/_routing-cloud';
import * as taskRoutingDocuware from './step/task/_routing-docuware';

/** ProcessFlow logic. */
const processFlowLogic = {
  useProcessFlow,

  data,
  layout,

  node,
  edge,

  step: {
    ...step,
    task: {
      ...taskCommon,
      connector: taskConnector,
      routing: {
        cloud: taskRoutingCloud,
        docuware: taskRoutingDocuware,
      },
      import: taskImport,
    },
    condition: {
      ...condition,
      path: conditionPath,
    },
    connector: {
      rcip: connectorRcip,
    },
    action: {
      detectBarcode,
    },
  },
};

export type { EdgeOptions, NodeOptions } from './_data.type';
export type { ProcessFlowStepData } from './step/_step.type';
export type { ConnectorSettingsFormField } from './step/task/_connector.type';
export type {
  RoutingSettingsFileCsvFormField,
  RoutingSettingsFileFormField,
  RoutingSettingsFileJsonFormField,
  RoutingSettingsFilePdfFormField,
  RoutingSettingsFileTiffFormField,
  RoutingSettingsFileXmlFormField,
} from './step/task/_routing-cloud.type';
export type { ProcessFlowStepConnectorRcipParamFormField, ProcessFlowStepConnectorRcipParamsFormField } from './step/connector/_rcip.type';
export type { ProcessFlowStepRoutingDocuwareFieldsFormField } from './step/task/_routing-docuware.type';
export type { ChildNodeResult } from './_node.type';

export default processFlowLogic;
